import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'formik';
import * as _ from 'lodash';
import propTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { getErrorLabelForPath, pathHasError } from '../../utils/form-utils';
import IconWithTooltip from '../IconWithTooltip';

const InputWithFormik = ({
  classes,
  formik,
  name,
  label,
  t,
  i18n,
  tReady,
  uppercase,
  lowercase,
  inputProps,
  ...props
}) => {
  const value =
    _.get(formik.values, name) === 0 ? 0 : _.get(formik.values, name) || '';
  const error = pathHasError(name, formik.touched, formik.errors);

  const helperText =
    props.helperText ||
    getErrorLabelForPath(name, formik.touched, formik.errors, t);

  const onBlur = formik.handleBlur;
  const onChange = formik.handleChange;
  const InputLabelProps = {
    shrink: true
    // style: {fontSize: 20,
    //   background: 'white',
    //   borderRadius: '4px',
    //   borderColor: 'brown',
    //   padding: '4px',
    //   border: '1px solid #e2e2e1',
    //   marginTop: '-6px',
    //   marginLeft: '-4px'
    // }
  };
  const innerProps = {
    name,
    label: props.tooltip ? (
      <>
        {label} <IconWithTooltip title={props.tooltip} />
      </>
    ) : (
      label
    ),
    className: classes.input,
    value,
    error,
    helperText: helperText || ' ',
    onBlur,
    onChange: (e, target) => {
      onChange(e, target);
      if (uppercase) {
        formik.setFieldValue(name, e.target.value.toUpperCase());
      }
      if (lowercase) {
        formik.setFieldValue(name, e.target.value.toLowerCase());
      }
    },
    fullWidth: true,
    variant: props.variant || 'outlined',
    inputProps: {
      ...inputProps,
      ...(uppercase && {
        style: {
          textTransform: 'uppercase',
          ...(inputProps && inputProps.style)
        }
      }),
      ...(lowercase && {
        style: {
          textTransform: 'lowercase',
          ...(inputProps && inputProps.style)
        }
      })
    }
    // size: "small"
  };
  const textFieldProps = { ...innerProps, ...props, InputLabelProps };
  return <TextField {...textFieldProps} />;
};

InputWithFormik.propTypes = {
  name: propTypes.string.isRequired,
  label: propTypes.string
};

const styles = () => ({
  // input: {
  //   borderRadius: 4,
  //   backgroundColor: '#DEE4E7'
  // }
});

export default withStyles(styles)(withTranslation()(connect(InputWithFormik)));
